import React from "react"
import FieldDropdown from "../../../dropdown";

// const debug = "FieldDropdown_FormValueNotEmpty"
const debug = false

type Props = {
    className?      : string,
    children        : any
    option          : Option
    configOptions   : any
    field           : FieldDropdown
    disabled        : boolean
    onClick         : callback
}

export default function FieldDropdown_FormValueNotEmpty(props:Props) {

    const {option}      = props
    let label : any     = props.option.label

    const optionColor = _.get(option, 'color', null)
    if (optionColor) {
        const pillClasses = ''
        const style = {
            color   : gd.skin.colors.mainColor({
                corePalette     : props.field.colorPalette,
                colorNumber     : optionColor
            })
        }
        label = (
            <div className={pillClasses} style={style}>
                {option.label}
            </div>
        )
    }

    const size      = _.get(props.configOptions, 'size', '36')
    const showIcon  = _.get(props.configOptions, 'showIcon', false)
    const hideLabel = _.get(props.configOptions, 'hideLabel', false)

    const valueClasses = Classes("ui5-field-form-editable dropdown-form not-selectable", 'h-{0}'.f(size), props.className, {
        'colored-value-selected': !!optionColor
    })

    const labelClasses = Classes('dropdown-label txt-truncate', {
        'ui5-txt-default'           : !props.disabled,
        'ui5-txt-no-accent-default' : props.disabled,
    })

    let valueIcon = _.get(props.field.components, 'ValueIcon', false)

    if (!valueIcon && showIcon && (props.option.icon || props.option.iconComponent)) {
        valueIcon = props.option.iconComponent || <div className={Classes("ui5-ico-14 m-r-10", props.option.icon)}/>
    }

    debug && console.log(debug, 'render', valueIcon, props.option)

    return (
        <>
            <div className={valueClasses} onClick={props.onClick}>
                {valueIcon}
                {!hideLabel && <div className={labelClasses}>{label}</div>}
            </div>
            {props.children}
        </>
    )
}